import React from 'react';
import { Card, CardBody } from '@one-thd/sui-atomic-components';
import { PaintPurchaseHistory } from '@thd-olt-component-react/paint-purchase-history';
import { getSvocId, getUserId } from '../../utils/user';
import { TMXProfileID } from '../../api/axios-client';
import { useShouldShowComponent } from '../../hooks/use-should-show-component';
export var PaintPurchaseHistoryContainer = function () {
    var userId = getUserId();
    var svocId = getSvocId();
    var data = useShouldShowComponent({ queryName: 'paintOrderHistory' }).data;
    return (React.createElement(Card, { className: (data === null || data === void 0 ? void 0 : data.paintOrderLineItems) ? '' : 'sui-hidden', grow: true },
        React.createElement(CardBody, null,
            React.createElement(PaintPurchaseHistory, { userId: userId, customerAccountId: svocId, tmxProfileId: TMXProfileID }))));
};
